const publicPath = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

const snowflakeSolverBooks = [
  {
    id: 'snowflake-sudoku',
    title: 'Snowflake Sudoku',
    coverUrl: publicPath('/images/Snowflake_Sudoku.jpg'),
    puzzleCount: 360,
    solverFamily: 'snowflake',
    cellCount: 42,
    sortOrder: 1,
  },
  {
    id: 'snowflake-bunny-slope',
    title: 'Snowflake Sudoku: Bunny Slope',
    coverUrl: publicPath('/images/Bunny_slope.png'),
    puzzleCount: 320,
    solverFamily: 'snowflake',
    cellCount: 42,
    sortOrder: 2,
  },
  {
    id: 'snowflake-blue-square',
    title: 'Snowflake Sudoku: Blue Square',
    coverUrl: publicPath('/images/Blue_square.png'),
    puzzleCount: 320,
    solverFamily: 'snowflake',
    cellCount: 42,
    sortOrder: 3,
  },
  {
    id: 'snowflake-double-black-diamond',
    title: 'Snowflake Sudoku: Double Black Diamond',
    coverUrl: publicPath('/images/Black_diamond.png'),
    puzzleCount: 320,
    solverFamily: 'snowflake',
    cellCount: 42,
    sortOrder: 4,
  },
];

const tridokuSolverBooks = [
  {
    id: 'tridoku-volume-1',
    title: 'Tridoku: Volume 1',
    coverUrl: publicPath('/images/Tridoku_Volume_1.png'),
    puzzleCount: 240,
    solverFamily: 'tridoku',
    cellCount: 81,
    sortOrder: 5,
  },
  {
    id: 'tridoku-volume-2',
    title: 'Tridoku: Volume 2',
    coverUrl: publicPath('/images/Tridoku_Volume_2.png'),
    puzzleCount: 240,
    solverFamily: 'tridoku',
    cellCount: 81,
    sortOrder: 6,
  },
  {
    id: 'tridoku-volume-3',
    title: 'Tridoku: Volume 3',
    coverUrl: publicPath('/images/Tridoku_Volume_3.png'),
    puzzleCount: 240,
    solverFamily: 'tridoku',
    cellCount: 81,
    sortOrder: 7,
  },
];

const numberKingdomsSolverBooks = [
  {
    id: 'number-kingdoms',
    title: 'Number Kingdoms',
    coverUrl: publicPath('/images/Number_Kingdoms.png'),
    puzzleCount: 320,
    solverFamily: 'number-kingdoms',
    cellCount: 48,
    sortOrder: 8,
  },
];

const battleshipSolverBooks = [
  {
    id: 'battleship',
    title: 'Battleship: 320 Puzzles',
    coverUrl: publicPath('/images/Battleship.png'),
    puzzleCount: 320,
    solverFamily: 'battleship',
    cellCount: 100,
    sortOrder: 9,
  },
];

export const solverBooks = [...snowflakeSolverBooks, ...tridokuSolverBooks, ...numberKingdomsSolverBooks, ...battleshipSolverBooks].sort(
  (left, right) => left.sortOrder - right.sortOrder
);

export const getSolverBook = (bookCode) =>
  solverBooks.find((book) => book.id === bookCode);

export default solverBooks;
